import { Template } from './Template';

export class Templates {
  public templates: Template[];
}
